module.exports = __webpack_public_path__ + "static/media/no_more_bets.89ca15fa.mp3";